<div class="drive__folder">
    <iframe [class.d-none]="loading || (folderLink$ | async) == undefined || iframeError" [src]="(folderLink$ | async) | safe" (load)="uploadDone()" (error)="onIframeError()"></iframe>
    <ngx-skeleton-loader [theme]="{'height': '100%'}" *ngIf="loading"></ngx-skeleton-loader>
    <div *ngIf="iframeError && !loading" class="drive__folder-empty">
        <div class="drive__folder-error">
            <span translate>drive-folder.error.label</span>
            <a (click)="openChat()" translate>drive-folder.error.btn</a>
        </div>
    </div>
</div>